import React, { Component } from 'react';

import './App.css';
import Menu from './components/menu'
import About from './components/about'
import Timeline from './components/timeline'
import Introduction from './components/introduction'

class App extends Component {
  render(){
    return (
      <div id="colorlib-page">
        <div id="container-wrap">
            <Menu></Menu>
                      <div id="colorlib-main">
                        <Introduction></Introduction>
                        <About></About>
                        <Timeline></Timeline>
                      </div>
        </div>
      </div>
    )
  }
}

export default App;